/**
 * itemMatch.ts — 자료수집 항목 자동 완성 맞추기(2026-10-24 · 2026-10-28 모든 화면 같은 규칙)
 *  치는 글 → 맞는 항목(등록한 「자주 쓰는 항목」 먼저 · 이름 앞부분이 맞는 것 먼저) · 최대 n개
 *  쓰는 곳: ItemSuggest(자료수집 새 프로젝트 · 상세) · 대출 점검 서류 요청(DocRequestPicker)
 *  항목 모음(서버 /api/templates/item-library)에는 섹션이 없다 — 섹션은 회사 · 프로젝트마다 달라 따라오면 안 됨
 */
export interface MatchItem { label: string; fixed?: boolean }
const key = (s: unknown) => String(s || '').replace(/\s+/g, '').toLowerCase();

export function matchItems<T extends MatchItem>(list: T[] | null | undefined, q: string, n = 6): T[] {
  const k = key(q);
  if (!k) return [];
  const words = String(q).trim().split(/\s+/).map(key).filter(Boolean);
  const hit = (list || []).filter(x => { const L = key(x.label); return L.includes(k) || (words.length > 1 && words.every(w => L.includes(w))); });
  const rank = (x: T) => (x.fixed ? 0 : 2) + (key(x.label).startsWith(k) ? 0 : 1);
  return hit.map((x, i) => ({ x, i })).sort((a, b) => rank(a.x) - rank(b.x) || a.i - b.i).slice(0, n).map(o => o.x);
}
